<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="form-group">
              <label class="d-block text-black fw-semibold mb-10">
                Date Opération <span class="text-danger">*</span>
              </label>
              <input v-model="dateControl" name="dateOperation" type="datetime-local" :max="currentDateTime"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Date oper." />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Magasin
              </label>
              <Multiselect :options="magasinOptions" :searchable="true" v-model="_magasin"
                placeholder="Sélectionner le magasin" />
            </div>
          </div>

          <div class="col-md-5">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Fiche de stock
              </label>
              <Multiselect v-model="_fiche" :options="produitOptions" :searchable="true" :disabled="prodEtat"
                placeholder="Sélectionner une fiche" />
            </div>
          </div>
          <!-- <div class="col-md-4">
              <div class="form-group ">
                  <label class="d-block text-black fw-semibold mb-10">
                      Type Operation 
                  </label>
                  <Multiselect :searchable="true" :options="lestypes"  v-model="_type"
                    placeholder="Choisir" />
              </div>
          </div> -->
          <!-- <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Motif d'Opération
              </label>
                <Multiselect
                  v-model="_motif"
                  :options="motifSuiviOptions" 
                  :searchable="true"
                  placeholder="Sélectionner le motif"
                />
            </div>
          </div> -->
          <div class="col-md-9">
            <div class="form-group  mt-2">
              <label class=" fw-semibold mb-1">
                Observation Générale
              </label>
              <textarea class="form-control" rows="1"></textarea>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group  mt-2">
              <label class=" fw-semibold mb-5">
              </label>
              <button :disabled="(selectedItems.length <= 0 || _fiche == '')" @click="valider(selectedItems)"
                class="btn btn-success me-3 mt-10" type="submit">
                Valider tous les mouvements
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                <input type="checkbox" class="form-check form-check-input" :checked="allChecked" @change="toggleAll" />
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date opér.
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                N°Fiche
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Client
              </th>
              <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Magasin
              </th> -->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Qté
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Stock
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type Opér.
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Motif
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Ref. Doc.
              </th>
              <th scope="col-md-2" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Oservation
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(mouvement, index) in mouvements" :key="index">
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                <input type="checkbox" :value="mouvement.id" :checked="isChecked(mouvement.id)"
                  @change="toggleItem(mouvement)" class="form-check form-check-input" />
              </th>
              <td class="shadow-none lh-1 fw-medium ">
                {{ format_date(mouvement?.dateOperation) }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement?.ficheProduit.numFiche }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                {{
                  mouvement?.produitCondiBon?.bon?.client
                    ? (mouvement.produitCondiBon.bon.client.nomClient && mouvement.produitCondiBon.bon.client.prenomClient
                      ? mouvement.produitCondiBon.bon.client.nomClient + ' ' +
                      mouvement.produitCondiBon.bon.client.prenomClient
                      : mouvement.produitCondiBon.bon.client.raisonSociale || 'Client sans nom')
                    : mouvement?.produitCondiBon?.bon?.fournisseur
                      ? (mouvement.produitCondiBon.bon.fournisseur.nomFournisseur &&
                        mouvement.produitCondiBon.bon.fournisseur.prenomFournisseur
                        ? mouvement.produitCondiBon.bon.fournisseur.nomFournisseur + ' ' +
                        mouvement.produitCondiBon.bon.fournisseur.prenomFournisseur
                        : mouvement.produitCondiBon.bon.fournisseur.raisonSociale || 'Fournisseur sans nom')
                      : 'Aucune entité associée'
                }}
              </td>
              <!-- <td class="shadow-none lh-1 fw-medium "  >
                {{ mouvement?.ficheProduit.magasin?.nomMagasin }}
              </td> -->
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement.qte }} {{ mouvement?.produitCondiBon.uniteMesure }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement.stockActuel }} {{ mouvement?.ficheProduit.conditionnement.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement.typeOperation }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement?.produitCondiBon.bon.motifSuivi?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement?.produitCondiBon.bon.refDoc }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <textarea class="form-control" v-model="mouvement.observation" rows="1"></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { Form, Field } from 'vee-validate';
import ApiService from "@/services/ApiService";
import { useRouter } from 'vue-router';
import { Mouvements } from "@/models/Mouvement";
import { format_date, suppression, format_Date, separateur, error, success,getCurrentDateTime } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import Swal from "sweetalert2";

export default defineComponent({
  name: "AddControl",
  components: {
    Form,
    Field,
    Multiselect,
    PaginationComponent,
  },
  setup: () => {
    const mouvements = ref<Array<Mouvements>>([]);
    const mouvement = ref<Mouvements>();
    const produitOptions = ref([]);
    const magasinOptions = ref([]);
    const magasin = ref([]);
    const produit = ref([]);
    const selectedEtat = ref('');
    const prodEtat = ref(true);

    // BEGIN PAGINATE
    const _fiche = ref('');
    const _magasin = ref('');
    const magasins = ref();
    const _bureau = ref('');
    const _type = ref('');
    const _motif = ref('');
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const router = useRouter();
    const dateControl = ref(getCurrentDateTime());
    const currentDateTime = ref(getCurrentDateTime());
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllMouvements(page_, limit_);
      } catch (error) {
        //
      }
    };
    const motifSuiviOptions = ref([])

    const fetchMotifSuivi = async () => {
      try {
        const response = await ApiService.get("/all/motifSuivis");
        const invData = response.data.data.data;
        motifSuiviOptions.value = invData.map((inv) => ({
          value: inv.id,
          label: `${inv.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const selectedItems = ref([]);

    const allChecked = computed(() => selectedItems.value.length === mouvements.value.length);

    const toggleAll = () => {
      if (allChecked.value) {
        selectedItems.value = [];
      } else {
        selectedItems.value = mouvements.value.map(item => ({ id: item.id, name: item.observation }));
      }
      console.log(selectedItems.value, "selectedItemsselectedItemsselectedItemsselectedItemsselectedItems");
    };


    // Vérifier si un élément est sélectionné
    const isChecked = (id) => selectedItems.value.some(item => item.id === id);

    // Ajouter/enlever un élément de selectedItems
    const toggleItem = (item) => {
      const index = selectedItems.value.findIndex(el => el.id === item.id);
      if (index === -1) {
        selectedItems.value.push({ id: item.id, observation: item.observation });
      } else {
        selectedItems.value.splice(index, 1);
      }
      console.log(selectedItems.value, "selectedItemsselectedItemsselectedItemsselectedItemsselectedItems");
    };

    const lestypes = ref([
      { value: "Entrée", label: "Entrée" },
      { value: "Sortie", label: "Sortie" }
    ]);


    watch(_fiche, () => {
      selectedItems.value = [];
      rechercher();
    });

    watch(_type, () => {
      rechercher();
    });

    watch(_motif, () => {
      rechercher();
    });

    watch(searchTerm, () => {
      rechercher();
    });
    watch(_magasin, async (newValue, oldValue) => {
      rechercher();
      if (newValue != oldValue) {
        await fetchProduits(newValue)
      }
    });

   

    watch(selectedEtat, () => {
      if (selectedEtat.value == 'Tout')
        selectedEtat.value = '';
      rechercher();
    });

    function rechercher() {
      getAllMouvements(page.value, limit.value, searchTerm.value, _motif.value, _magasin.value, _fiche.value, selectedEtat.value, _type.value);
    }

    const fetchProduits = async (magasin: any) => {
      ApiService.get(`/ficheproduit/mag/${magasin}`)
        .then(({ data }) => {
          console.log("TTTTTTTTTTTTTT ===> ", data);
          const donnees = data.data;
          if (donnees && donnees.length > 0) {
            prodEtat.value = false
          } else {
            prodEtat.value = true;
          }
          produitOptions.value = donnees.map((produit) => {
            return {
              value: produit.id,
              label: produit.numFiche + '-' + produit.nomProduit,
            }
          });
        })
        .catch(({ response }) => {
          console.log("TYYYTYYTYTYT ===> ", response)
          // error(response.data.message)
        });
    }


    const fetchMagasins = async () => {
      ApiService.get("/all/magasins")
        .then(({ data }) => {
          const donnees = data.data.data;
          magasinOptions.value = donnees.map((magasin) => {
            return {
              value: magasin.id,
              label: magasin.nomMagasin,
            }
          });
        })
        .catch(({ response }) => {
          // error(response.data.message)
        });
    }

    function getAllMouvements(page = 1, limi = 10, searchTerm = '', _motif = '', _magasin = '', _fiche = '', selectedEtat = '', type = "") {
      return ApiService.get(`/mouvementfiches?page=${page}&limit=${limi}&mot=${searchTerm}&motif=${_motif}&magasin=${_magasin}&fiche=${_fiche}&etat=${selectedEtat}&type=${type}&statut=0`)
        .then(({ data }) => {
          mouvements.value = data.data.data
          console.log("MOOOOOOOOOUUUUUUUUUVE ===>", mouvements.value);
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          // error(response.data.message);
        });
    }

    const valider = async (id: any) => {
      Swal.fire({
        text: `Vous êtes sur le point de valider ${id.length} mouvement(s) .\n Etes-vous sûr ?`,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Valider",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger"
        },
      }).then(async (result) => {
        try {
          if (result.isConfirmed) {
            const response = await ApiService.post("/controlfiche", { dateControl:dateControl.value, ficheProduit: _fiche.value, magasin: _magasin.value, controlMoves: selectedItems.value });
            if (response.data.code == 201) {
              rechercher();
              success(response.data.message);
              router.push({ name: "ListeMouvementFiche" });
            }
          } else {
            error("Vous avez annulé la soumission");
          }

        } catch (response) {
          error(response.message);
        }
      })
    }

    onMounted(() => {
      getAllMouvements();
      fetchMagasins();
      fetchMotifSuivi();
      //getAllMagasin();
    });



    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return {
      dateControl,
      currentDateTime,
      mouvements,
      selectedItems,
      allChecked,
      mouvement,
      computed,
      toggleAll,
      checkPermission,
      produitOptions,
      magasinOptions,
      format_date,
      suppression,
      getAllMouvements,
      page,
      totalPages,
      limit,
      format_Date,
      totalElements,
      handlePaginate,
      valider,
      _type,
      _motif,
      lestypes,
      separateur,
      searchTerm,
      _bureau,
      prodEtat,
      _magasin, magasins,
      _fiche, magasin, produit,
      rechercher, toggleItem, isChecked,
      Multiselect,
      motifSuiviOptions,
      selectedEtat
    };
  },
});
</script>
